import React from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';

interface OtherInformationDataPackageFeatureProps {
    dataPackageId: string;
    onValidation?: (valid: boolean) => void;
}

export const OtherInformationDataPackageFeature = ({ dataPackageId, onValidation }: OtherInformationDataPackageFeatureProps) => (
    <DataPackageV2Component
        dataPackageId={dataPackageId}
        allowDownload={false}
        allowUpload={true}
        allowDelete={true}
        allowSubmit={false}
        availableTypes={['Research Proposal Supplement', 'Funding Information', 'Statistical Analysis Plan', 'Other', 'Unknown']}
        onValidation={onValidation}
        title="File Attachments"
    />
);
